export default __webpack_public_path__ + "static/media/panTech1Full.9ab71618.png";